import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchReclamationTransporteur } from 'store/reclamation/reclamationsActions';
import { fetchReclamationInfosLogistique } from 'store/reclamation/detailsActions';
import { fetchTransporteurs } from 'store/transporteur/transporteurActions';
import DemanderRechercheColisDialogContent from './DemanderRechercheColisDialogContent';
import withLoader from 'components/Shared/withLoader';

const DemanderRechercheColisDialogContentWithLoader = withLoader(DemanderRechercheColisDialogContent);

class DemanderRechercheColisDialogContentContainer extends React.Component {


    async componentDidMount() {
        await this.props.fetchTransporteurs();
        await this.props.fetchReclamationTransporteur(this.props.reclamationId);
        await this.props.fetchReclamationInfosLogistique(this.props.reclamationId);
    }

    render() {
        const { isLoading, onChange, action, transporteurId, transporteurs, colis, depotDepart } = this.props;

        return (
            <DemanderRechercheColisDialogContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                transporteurId={transporteurId}
                colis={colis}
                transporteurs={transporteurs}
                depotDepart={depotDepart}
            />
        );
    }
}

DemanderRechercheColisDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    let transporteur = state.reclamation.reclamations.transporteurs.items.find(x => x.reclamationId === props.reclamationId);
    let isLoading = state.reclamation.reclamations.transporteurs.isLoading || state.transporteur.transporteurs.isLoading || state.reclamation.details.isInfosLogistiqueLoading;

    var depotDepart = state.reclamation.details.infosLogistique ? state.reclamation.details.infosLogistique.depotDepart : '';

    return {
        isLoading: isLoading,
        transporteurId: (transporteur && transporteur.transporteurId !== -1) ? transporteur.transporteurId : '',
        transporteurs: state.transporteur.transporteurs.items,
        colis: transporteur ? transporteur.colis : [],
        depotDepart: depotDepart
    };
};

const mapDispatchToProps = {
    fetchTransporteurs,
    fetchReclamationTransporteur,
    fetchReclamationInfosLogistique
};

export default connect(mapStateToProps, mapDispatchToProps)(DemanderRechercheColisDialogContentContainer);